const roundMoney = (value) => Number(Number(value || 0).toFixed(2));

export const repriceCartWithItems = (cart, items) => {
  const current = cart || {};
  const validItems = items.filter((item) => Number(item.quantity) > 0);
  const itemTotal = roundMoney(
    validItems.reduce(
      (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0),
      0
    )
  );
  const totalQuantity = validItems.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );
  const packingCharges = roundMoney(
    Number(current.packing_charge_per_unit || 0) * totalQuantity
  );
  const subtotal = roundMoney(itemTotal + packingCharges);
  const foodGst = roundMoney(subtotal * 0.05);
  const deliveryFee = validItems.length ? Number(current.delivery_fee || 0) : 0;
  const platformFee = validItems.length ? Number(current.platform_fee || 0) : 0;
  const serviceGst = validItems.length
    ? roundMoney((deliveryFee + platformFee) * 0.18)
    : 0;

  return {
    ...current,
    items: validItems,
    item_total: itemTotal,
    total_quantity: totalQuantity,
    packing_charges: packingCharges,
    subtotal,
    food_gst: validItems.length ? foodGst : 0,
    delivery_fee: deliveryFee,
    platform_fee: platformFee,
    service_gst: serviceGst,
    gst: roundMoney((validItems.length ? foodGst : 0) + serviceGst),
    total: validItems.length
      ? roundMoney(subtotal + foodGst + deliveryFee + platformFee + serviceGst)
      : 0,
  };
};
